
export const luminTenants = {
    lumin: "lumin",
    service1: "service1",
    //riverfront: "riverfront"
};

export const isLuminServiceProvider = (props, fromProps = true) => {
    if (!fromProps) {
        return Object.values(luminTenants).includes(props);
    }
    return Object.values(luminTenants).includes(props?.state?.theme?.values?.tenantFullName);
}

export const isService1Tenant = (props, fromProps = true) => {
    const luminTenants = { service1: "service1" };
    if (!fromProps) {
        return Object.values(luminTenants).includes(props);
    }
    return Object.values(luminTenants).includes(props?.state?.theme?.values?.tenantFullName);
}

export const isRiverfrontTenant = (props, fromProps = true) => {
    const luminTenants = { riverfront: "riverfront" };
    if (!fromProps) {
        return Object.values(luminTenants).includes(props);
    }
    return Object.values(luminTenants).includes(props?.state?.theme?.values?.tenantFullName);
}